// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.practicepay.PracticePayCreatePaymentTransactionRequest */
/* istanbul ignore next */
@GandalfModel
export class PracticePayCreatePaymentTransactionRequest extends GandalfModelBase {

	@GandalfLabel('Error Code')
	@GandalfValidator({ sizeString: { message: 'Error Code cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	errorCode!: string | null;

	@GandalfLabel('Error Message')
	@GandalfValidator({ sizeString: { message: 'Error Message cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	errorMessage!: string | null;

	@GandalfLabel('Practice Location')
	@GandalfValidator({ notNull: { message: 'Practice Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

	@GandalfLabel('Status')
	@GandalfValidator({ notNull: { message: 'Status is required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	status!: string;

	@GandalfLabel('Transaction Identifier')
	@GandalfValidator({ notNull: { message: 'Transaction Identifier is required' } })
	@GandalfValidator({ sizeString: { message: 'Transaction Identifier must be between 1 and 4000 characters', minLength: 1, maxLength: 4000 } })
	@GandalfProperty({ designType: String, isRequired: true })
	transactionIdentifier!: string;

	@GandalfConstantDecorator(constants.PaymentTransactionModality)
	@GandalfLabel('Transaction Modality')
	@GandalfValidator({ notNull: { message: 'Transaction Modality is required' } })
	@GandalfProperty({ designType: constants.PaymentTransactionModality, isRequired: true })
	transactionModality!: constants.PaymentTransactionModality;

	@GandalfConstantDecorator(constants.PaymentTransactionType)
	@GandalfLabel('Transaction Type')
	@GandalfValidator({ notNull: { message: 'Transaction Type is required' } })
	@GandalfProperty({ designType: constants.PaymentTransactionType, isRequired: true })
	transactionType!: constants.PaymentTransactionType;

}
